import { ExtractFromObject } from "./extract-from-object";

// biome-ignore lint/complexity/noBannedTypes: the type function is what we want here
export type ExtractFunctionNames<T> = ExtractFromObject<T, Function>;
